import React from "react";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import PaidOutlined from "@mui/icons-material/PaidOutlined";
import AccountBalanceWalletOutlined from "@mui/icons-material/AccountBalanceWalletOutlined";
import BarChartOutlined from "@mui/icons-material/BarChartOutlined";
import TrendingUpOutlined from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlined from "@mui/icons-material/TrendingDownOutlined";

const PayrollStats = () => {
  return (
    <div  className="row g-3 mt-3">

      {/* Highest Salary */}
      <div sx={{ borderRadius: "3px",    border: "1px solid #eee",
 }} className="col-12 col-sm-6 col-lg-3 col-xxl-6">
        <div className="card  shadow-sm h-100">
          <div className="card-body">

            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center"
                   style={{ width: 36, height: 36 }}>
                <WarningAmberOutlined style={{ fontSize: 18 }} />
              </div>
              <small className="text-muted">Highest Salary</small>
            </div>

            <div className="d-flex align-items-center gap-2 mb-1">
              <h5 className="fw-bold mb-0">$24,500</h5>

              <div className="d-flex align-items-center border rounded-pill px-2 py-1 small">
                <span className="me-1 small ">+18%</span>
                <span className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: 22, height: 22 }}>
                  <TrendingUpOutlined style={{ fontSize: 14 }} />
                </span>
              </div>
            </div>

            <small className="text-muted">CTO - Engineering</small>
          </div>
        </div>
      </div>

      {/* Variable Pay */}
      <div sx={{ borderRadius: "3px",    border: "1px solid #eee",
 }} className="col-12 col-sm-6 col-lg-3 col-xxl-6">
        <div className="card  shadow-sm h-100">
          <div className="card-body">

            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center"
                   style={{ width: 36, height: 36 }}>
                <PaidOutlined style={{ fontSize: 18 }} />
              </div>
              <small className="text-muted">Variable Pay</small>
            </div>

            <div className="d-flex align-items-center gap-2 mb-1">
              <h5 className="fw-bold mb-0">$284K</h5>

              <div className="d-flex align-items-center border rounded-pill px-2 py-1">
                <span className="me-1 small">+18%</span>
                <span className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: 22, height: 22 }}>
                  <TrendingUpOutlined style={{ fontSize: 14 }} />
                </span>
              </div>
            </div>

            <small className="text-muted">Bonuses + Commissions</small>
          </div>
        </div>
      </div>

      {/* After Deduction */}
      <div sx={{ borderRadius: "3px",    border: "1px solid #eee",
 }} className="col-12 col-sm-6 col-lg-3 col-xxl-6">
        <div className="card  shadow-sm h-100">
          <div className="card-body">

            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center"
                   style={{ width: 36, height: 36 }}>
                <AccountBalanceWalletOutlined style={{ fontSize: 18 }} />
              </div>
              <small className="text-muted">After Deduction</small>
            </div>

            <div className="d-flex align-items-center gap-2 mb-1">
              <h5 className="fw-bold mb-0">$1.99M</h5>

              <div className="d-flex align-items-center border rounded-pill px-2 py-1">
                <span className="me-1 small">-16%</span>
                <span className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: 22, height: 22 }}>
                  <TrendingDownOutlined style={{ fontSize: 14 }} />
                </span>
              </div>
            </div>

            <small className="text-muted">Employee take-home</small>
          </div>
        </div>
      </div>

      {/* Average Salary */}
      <div sx={{ borderRadius: "3px",    border: "1px solid #eee",
 }} className="col-12 col-sm-6 col-lg-3 col-xxl-6">
        <div className="card  shadow-sm h-100">
          <div className="card-body">

            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center"
                   style={{ width: 36, height: 36 }}>
                <BarChartOutlined style={{ fontSize: 18 }} />
              </div>
              <small className="text-muted">Average Salary</small>
            </div>

            <div className="d-flex align-items-center gap-2 mb-1">
              <h5 className="fw-bold mb-0">$78,450</h5>

              <div className="d-flex align-items-center border rounded-pill px-2 py-1">
                <span className="me-1 small">+18%</span>
                <span className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: 22, height: 22 }}>
                  <TrendingUpOutlined style={{ fontSize: 14 }} />
                </span>
              </div>
            </div>

            <small className="text-muted">Median: $72,000</small>
          </div>
        </div>
      </div>

    </div>
  );
};

export default PayrollStats;